import { LicenseType } from "@shared-features/enums/license-type.enum";
import { Nationality } from "@shared-features/enums/nationality.enum";

export class DriverWithTruck {

    firstName: string = '';
    lastName: string = '';
    fleetId: number= null;
    licenseAttachment: number= null;
    iqamaId: number= null;
    nonResidentId: number= null;
    mobileNumber: string = '';
    nationality: Nationality;
    profilePictureId: number= null;
    licenseType: LicenseType;
    truckId: number= null;
    driverLicenseExpiry: Date = null;
    iqamaIdExpiry: Date = null;
    birthDate: string = '';
    driverOwner: string = '';
    isLead: boolean;
    isFreelance: boolean;
    plateNumber: string = '';
    pictureId: number= null;
    brandId: number= null;
    truckTypeId: number= null;
    manufactureYear: number= null;
    sequenceNumber: number
    truckOwnerName: string = '';
    weight: number= null;
    volume: number = null;
    truckLicenseExpiry: Date = null;
    driverId: number= null;
    coDriverId: number= null;
    ownerId: number;
    plateNumberDetails: string;
}
